// Cloud Intercom Management APIs

/**
 * @function ApiClient#GetCloudIntercomStationList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCloudIntercomStationList(cid, options = {}) {
  return await this._get(`/community/${cid}/cloud-intercom/stations`, options);
}

/**
 * @function ApiClient#GetCloudIntercomHouseHoldList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCloudIntercomHouseHoldList(cid, options = {}) {
  return await this._get(`/community/${cid}/cloud-intercom/households`, options);
}

/**
 * @function ApiClient#GetCloudIntercomSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetCloudIntercomSetting(cid, options = {}) {
  return await this._get(`/community/${cid}/cloud-intercom/settings`, options);
}

/**
 * @function ApiClient#AddCloudIntercomStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} is
 * @param {any} options = {}
 */
export async function AddCloudIntercomStation(cid, is, options = {}) {
  return await this._post(`/community/${cid}/cloud-intercom/stations`, is, options);
}

/**
 * @function ApiClient#UpdateCloudIntercomSetting
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} setting
 * @param {any} options = {}
 */
export async function UpdateCloudIntercomSetting(cid, setting, options = {}) {
  return await this._put(`/community/${cid}/cloud-intercom/settings`, setting, options);
}

/**
 * @function ApiClient#UpdateCloudIntercomStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} is
 * @param {any} options = {}
 */
export async function UpdateCloudIntercomStation(cid, is, options = {}) {
  const stationId = is?.Id;
  return await this._put(`/community/${cid}/cloud-intercom/stations/${stationId}`, is, options);
}

/**
 * @function ApiClient#DeleteCloudIntercomStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} stationId
 * @param {any} options = {}
 */
export async function DeleteCloudIntercomStation(cid, stationId, options = {}) {
  return await this._delete(`/community/${cid}/cloud-intercom/stations/${stationId}`, options);
}

// 對講機系統管理 APIs

/**
 * @function ApiClient#GetIntercomStationList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.search 搜尋站點名稱。
 * @param {any} filters.limit 回傳筆數上限。
 * @param {any} options = {}
 */
export async function GetIntercomStationList(cid, { search = "", limit = "" } = {}, options = {}) {
  const query = new URLSearchParams();
  if (search) query.set("search", search);
  if (limit) query.set("limit", limit);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return await this._get(`/community/${cid}/ha/stations${suffix}`, options);
}

/**
 * @function ApiClient#GetIntercomHouseHoldList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.search 搜尋戶別名稱或地址。
 * @param {any} filters.building 棟別。
 * @param {any} filters.doorPlate 門牌。
 * @param {any} filters.floor 樓層。
 * @param {any} filters.limit 回傳筆數上限。
 * @param {any} options = {}
 */
export async function GetIntercomHouseHoldList(cid, { search = "", building = "", doorPlate = "", floor = "", limit = "" } = {}, options = {}) {
  const query = new URLSearchParams();
  if (search) query.set("search", search);
  if (building) query.set("building", building);
  if (doorPlate) query.set("doorPlate", doorPlate);
  if (floor) query.set("floor", floor);
  if (limit) query.set("limit", limit);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  return await this._get(`/community/${cid}/ha/households${suffix}`, options);
}

/**
 * @function ApiClient#AddIntercomStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} is
 * @param {any} options = {}
 */
export async function AddIntercomStation(cid, is, options = {}) {
  return await this._post(`/community/${cid}/ha/stations`, is, options);
}

/**
 * @function ApiClient#UpdateIntercomStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} is
 * @param {any} options = {}
 */
export async function UpdateIntercomStation(cid, is, options = {}) {
  const { Id: stationId, ...body } = is || {};
  return await this._put(`/community/${cid}/ha/stations/${stationId}`, body, options);
}

/**
 * @function ApiClient#DeleteIntercomStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} stationId
 * @param {any} options = {}
 */
export async function DeleteIntercomStation(cid, stationId, options = {}) {
  return await this._delete(`/community/${cid}/ha/stations/${stationId}`, options);
}

// 對講機系統設備管理 APIs

/**
 * @function ApiClient#GetIntercomHASettings
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetIntercomHASettings(cid, options = {}) {
  return await this._get(`/community/${cid}/ha/settings`, options);
}

// UpdateIntercomHASettings 更新對講機系統設定，包含 AlarmListenerPort 警報接收連接埠、EnableWH607OpenDoor 小門口機遠端開門能力、保存期限、通知同步與訊息模板。
/**
 * @function ApiClient#UpdateIntercomHASettings
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomHASettings(cid, data, options = {}) {
  return await this._put(`/community/${cid}/ha/settings`, data, options);
}

/**
 * @function ApiClient#GetIntercomNotificationTemplates
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetIntercomNotificationTemplates(cid, options = {}) {
  return await this._get(`/community/${cid}/ha/notification-templates`, options);
}

/**
 * @function ApiClient#UpdateIntercomNotificationTemplates
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomNotificationTemplates(cid, data, options = {}) {
  return await this._put(`/community/${cid}/ha/notification-templates`, data, options);
}

/**
 * @function ApiClient#GetIntercomSIPDefaults
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetIntercomSIPDefaults(cid, options = {}) {
  return await this._get(`/community/${cid}/ha/sip-defaults`, options);
}

/**
 * @function ApiClient#UpdateIntercomSIPDefaults
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomSIPDefaults(cid, data, options = {}) {
  return await this._put(`/community/${cid}/ha/sip-defaults`, data, options);
}

/**
 * @function ApiClient#GetIntercomSIPEndpointList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.search 搜尋分機、帳號或伺服器。
 * @param {any} filters.status 註冊狀態。
 * @param {any} filters.kind 分機用途。
 * @param {any} filters.enabled 啟用狀態。
 * @param {any} filters.p 頁碼。
 * @param {any} filters.pp 每頁筆數。
 * @param {any} options = {}
 */
export async function GetIntercomSIPEndpointList(cid, { search = "", status = "", kind = "", enabled = "", p = 1, pp = 20 } = {}, options = {}) {
  const query = new URLSearchParams({
    search,
    status,
    kind,
    enabled,
    p,
    pp,
  });
  return await this._get(`/community/${cid}/ha/sip/endpoints?${query.toString()}`, options);
}

/**
 * @function ApiClient#GetIntercomSIPDiagnostics
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.search 搜尋分機、帳號或社區主機。
 * @param {any} filters.status 註冊狀態。
 * @param {any} filters.kind 分機用途。
 * @param {any} filters.p 頁碼。
 * @param {any} filters.pp 每頁筆數。
 * @param {any} options = {}
 */
export async function GetIntercomSIPDiagnostics(cid, { search = "", status = "", kind = "", p = 1, pp = 15 } = {}, options = {}) {
  const query = new URLSearchParams({
    search,
    status,
    kind,
    p,
    pp,
  });
  return await this._get(`/community/${cid}/ha/sip/diagnostics?${query.toString()}`, options);
}

/**
 * @function ApiClient#CreateIntercomSIPEndpoint
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateIntercomSIPEndpoint(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ha/sip/endpoints`, data, options);
}

/**
 * @function ApiClient#ImportIntercomSIPEndpointFile
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} formData
 * @param {any} options = {}
 */
export async function ImportIntercomSIPEndpointFile(cid, formData, options = {}) {
  return await this._post(`/community/${cid}/ha/sip/import/confirm`, formData, options);
}

/**
 * @function ApiClient#PreviewIntercomSIPEndpointFile
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} formData
 * @param {any} options = {}
 */
export async function PreviewIntercomSIPEndpointFile(cid, formData, options = {}) {
  return await this._post(`/community/${cid}/ha/sip/import/preview`, formData, options);
}

/**
 * @function ApiClient#UpdateIntercomSIPEndpoint
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomSIPEndpoint(cid, data, options = {}) {
  const { Id: endpointId, ...payload } = data || {};
  return await this._put(`/community/${cid}/ha/sip/endpoints/${endpointId}`, payload, options);
}

/**
 * @function ApiClient#DeleteIntercomSIPEndpoint
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} endpointId
 * @param {any} options = {}
 */
export async function DeleteIntercomSIPEndpoint(cid, endpointId, options = {}) {
  return await this._delete(`/community/${cid}/ha/sip/endpoints/${endpointId}`, options);
}

/**
 * @function ApiClient#PreviewIntercomDeviceImport
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} formData
 * @param {any} options = {}
 */
export async function PreviewIntercomDeviceImport(cid, formData, options = {}) {
  return await this._post(`/community/${cid}/ha/addressbook/import/preview`, formData, options);
}

/**
 * @function ApiClient#ConfirmIntercomDeviceImport
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function ConfirmIntercomDeviceImport(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ha/addressbook/import/confirm`, data, options);
}

/**
 * @function ApiClient#GetIntercomDeviceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.type 設備類型。
 * @param {any} filters.bindStatus 綁定狀態。
 * @param {any} filters.online 連線狀態。
 * @param {any} filters.search 搜尋名稱、IP 或 RO。
 * @param {any} filters.p 頁碼。
 * @param {any} filters.pp 每頁筆數。
 * @param {any} options = {}
 */
export async function GetIntercomDeviceList(cid, { type = "", bindStatus = "", online = "", search = "", p = 1, pp = 50 } = {}, options = {}) {
  const query = new URLSearchParams({
    type,
    bindStatus,
    online,
    search,
    p,
    pp,
  });
  return await this._get(`/community/${cid}/ha/devices?${query.toString()}`, options);
}

// GetIntercomIndoorUnitList 讀取對講機系統室內機列表與註冊狀態。
/**
 * @function ApiClient#GetIntercomIndoorUnitList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetIntercomIndoorUnitList(cid, options = {}) {
  return await this._get(`/community/${cid}/ha/indoor-units`, options);
}

// GetIntercomIndoorUnitDetail 讀取單台對講機系統室內機狀態與設定。
/**
 * @function ApiClient#GetIntercomIndoorUnitDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} indoorUnitId
 * @param {any} options = {}
 */
export async function GetIntercomIndoorUnitDetail(cid, indoorUnitId, options = {}) {
  if (!indoorUnitId) {
    throw new Error("indoor unit id required");
  }
  return await this._get(`/community/${cid}/ha/indoor-units/${indoorUnitId}`, options);
}

// GetIntercomIndoorUnitPhoneSlots 讀取單台對講機系統室內機手機欄位狀態。
/**
 * @function ApiClient#GetIntercomIndoorUnitPhoneSlots
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} indoorUnitId
 * @param {any} options = {}
 */
export async function GetIntercomIndoorUnitPhoneSlots(cid, indoorUnitId, options = {}) {
  if (!indoorUnitId) {
    throw new Error("indoor unit id required");
  }
  return await this._get(`/community/${cid}/ha/indoor-units/${indoorUnitId}/phone-slots`, options);
}

// RegisterIntercomIndoorUnit 觸發單台對講機系統室內機重新執行註冊檢查。
/**
 * @function ApiClient#RegisterIntercomIndoorUnit
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} indoorUnitId
 * @param {any} options = {}
 */
export async function RegisterIntercomIndoorUnit(cid, indoorUnitId, options = {}) {
  if (!indoorUnitId) {
    throw new Error("indoor unit id required");
  }
  return await this._post(`/community/${cid}/ha/indoor-units/${indoorUnitId}/register`, {}, options);
}

// UpdateIntercomIndoorUnitCredential 更新單台對講機系統室內機註冊資料覆寫設定。
/**
 * @function ApiClient#UpdateIntercomIndoorUnitCredential
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} indoorUnitId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomIndoorUnitCredential(cid, indoorUnitId, data, options = {}) {
  if (!indoorUnitId) {
    throw new Error("indoor unit id required");
  }
  return await this._put(`/community/${cid}/ha/indoor-units/${indoorUnitId}/credential`, data, options);
}

// UpdateIntercomIndoorUnitOverwritePolicy 更新單台對講機系統室內機手機欄位覆蓋策略。
/**
 * @function ApiClient#UpdateIntercomIndoorUnitOverwritePolicy
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} indoorUnitId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomIndoorUnitOverwritePolicy(cid, indoorUnitId, data, options = {}) {
  if (!indoorUnitId) {
    throw new Error("indoor unit id required");
  }
  return await this._put(`/community/${cid}/ha/indoor-units/${indoorUnitId}/overwrite-policy`, data, options);
}

/**
 * @function ApiClient#UpdateIntercomDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomDevice(cid, data, options = {}) {
  const deviceId = data?.Id;
  return await this._put(`/community/${cid}/ha/devices/${deviceId}`, data, options);
}

/**
 * @function ApiClient#DeleteIntercomDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} options = {}
 */
export async function DeleteIntercomDevice(cid, did, options = {}) {
  return await this._delete(`/community/${cid}/ha/devices/${did}`, options);
}

/**
 * @function ApiClient#BindIntercomDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} householdId
 * @param {any} options = {}
 */
export async function BindIntercomDevice(cid, did, householdId, options = {}) {
  return await this._post(`/community/${cid}/ha/devices/${did}/bind`, { HouseholdId: householdId }, options);
}

/**
 * @function ApiClient#UnbindIntercomDevice
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} options = {}
 */
export async function UnbindIntercomDevice(cid, did, options = {}) {
  return await this._delete(`/community/${cid}/ha/devices/${did}/bind`, options);
}

/**
 * @function ApiClient#BindIntercomDeviceStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} stationId
 * @param {any} options = {}
 */
export async function BindIntercomDeviceStation(cid, did, stationId, options = {}) {
  return await this._post(`/community/${cid}/ha/devices/${did}/bind-station`, { StationId: stationId }, options);
}

/**
 * @function ApiClient#UnbindIntercomDeviceStation
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} did
 * @param {any} options = {}
 */
export async function UnbindIntercomDeviceStation(cid, did, options = {}) {
  return await this._delete(`/community/${cid}/ha/devices/${did}/bind-station`, options);
}

/**
 * @function ApiClient#GetIntercomAlarmList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.householdId 戶別 ID。
 * @param {any} filters.status 處理狀態。
 * @param {any} filters.ro RO 編碼。
 * @param {any} filters.alarmType 警報類型。
 * @param {any} filters.deviceId 設備 ID。
 * @param {any} filters.p 頁碼。
 * @param {any} filters.pp 每頁筆數。
 * @param {any} options = {}
 */
export async function GetIntercomAlarmList(cid, { householdId = "", status = "", ro = "", alarmType = "", deviceId = "", p = 1, pp = 15 } = {}, options = {}) {
  const query = new URLSearchParams({
    householdId,
    status,
    ro,
    alarmType,
    deviceId,
    p,
    pp,
  });
  return await this._get(`/community/${cid}/ha/alarms?${query.toString()}`, options);
}

/**
 * @function ApiClient#GetIntercomAlarmDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} alarmId
 * @param {any} options = {}
 */
export async function GetIntercomAlarmDetail(cid, alarmId, options = {}) {
  return await this._get(`/community/${cid}/ha/alarms/${alarmId}`, options);
}

/**
 * @function ApiClient#UpdateIntercomAlarmStatus
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} alarmId
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateIntercomAlarmStatus(cid, alarmId, data, options = {}) {
  return await this._put(`/community/${cid}/ha/alarms/${alarmId}/status`, data, options);
}

/**
 * @function ApiClient#AssignIntercomAlarm
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} alarmId
 * @param {any} assigneeId
 * @param {any} options = {}
 */
export async function AssignIntercomAlarm(cid, alarmId, assigneeId, options = {}) {
  return await this._put(`/community/${cid}/ha/alarms/${alarmId}/assignee`, { AssigneeId: assigneeId }, options);
}

/**
 * @function ApiClient#AddIntercomAlarmNote
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} alarmId
 * @param {any} content
 * @param {any} options = {}
 */
export async function AddIntercomAlarmNote(cid, alarmId, content, options = {}) {
  return await this._post(`/community/${cid}/ha/alarms/${alarmId}/notes`, { Content: content }, options);
}

/**
 * @function ApiClient#MarkIntercomAlarmRead
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} alarmId
 * @param {any} options = {}
 */
export async function MarkIntercomAlarmRead(cid, alarmId, options = {}) {
  return await this._put(`/community/${cid}/ha/alarms/${alarmId}/read`, {}, options);
}

/**
 * @function ApiClient#GetIntercomCommandList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.commandType 命令類型。
 * @param {any} filters.status 執行狀態。
 * @param {any} filters.search 搜尋設備、戶別或社區主機。
 * @param {any} filters.householdId 戶別 ID。
 * @param {any} filters.from 起始日期。
 * @param {any} filters.to 結束日期。
 * @param {any} filters.p 頁碼。
 * @param {any} filters.pp 每頁筆數。
 * @param {any} options = {}
 */
export async function GetIntercomCommandList(
  cid,
  { commandType = "", status = "", search = "", householdId = "", from = "", to = "", p = 1, pp = 15 } = {},
  options = {},
) {
  const query = new URLSearchParams({
    commandType,
    status,
    search,
    householdId,
    from,
    to,
    p,
    pp,
  });
  return await this._get(`/community/${cid}/ha/commands?${query.toString()}`, options);
}

/**
 * @function ApiClient#GetIntercomCommandDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} trackId
 * @param {any} options = {}
 */
export async function GetIntercomCommandDetail(cid, trackId, options = {}) {
  return await this._get(`/community/${cid}/ha/commands/${trackId}`, options);
}

/**
 * @function ApiClient#CallIntercomHAElevator
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} householdId
 * @param {any} options = {}
 */
export async function CallIntercomHAElevator(cid, householdId, options = {}) {
  return await this._post(`/community/${cid}/ha/households/${householdId}/elevator-call`, {}, options);
}

/**
 * @function ApiClient#GetIntercomIndoorMessageList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.status 訊息狀態。
 * @param {any} filters.p 頁碼。
 * @param {any} filters.pp 每頁筆數。
 * @param {any} options = {}
 */
export async function GetIntercomIndoorMessageList(cid, { status = "", p = 1, pp = 20 } = {}, options = {}) {
  const query = new URLSearchParams({
    status,
    p,
    pp,
  });
  return await this._get(`/community/${cid}/ha/indoor-messages?${query.toString()}`, options);
}

/**
 * @function ApiClient#CreateIntercomIndoorMessage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} data
 * @param {any} options = {}
 */
export async function CreateIntercomIndoorMessage(cid, data, options = {}) {
  return await this._post(`/community/${cid}/ha/indoor-messages`, data, options);
}

/**
 * @function ApiClient#GetIntercomIndoorMessageDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} messageId
 * @param {any} options = {}
 */
export async function GetIntercomIndoorMessageDetail(cid, messageId, options = {}) {
  return await this._get(`/community/${cid}/ha/indoor-messages/${messageId}`, options);
}

/**
 * @function ApiClient#GetIntercomIndoorMessageDeliveries
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} messageId
 * @param {any} options = {}
 */
export async function GetIntercomIndoorMessageDeliveries(cid, messageId, options = {}) {
  return await this._get(`/community/${cid}/ha/indoor-messages/${messageId}/deliveries`, options);
}

/**
 * @function ApiClient#CancelIntercomIndoorMessage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} messageId
 * @param {any} options = {}
 */
export async function CancelIntercomIndoorMessage(cid, messageId, options = {}) {
  return await this._post(`/community/${cid}/ha/indoor-messages/${messageId}/cancel`, {}, options);
}
